export default "__VITE_ASSET__a59ef873__"